module.exports = __webpack_public_path__ + "img/2.da5b5fb3.png";